module.exports = __webpack_public_path__ + "static/media/8.9efc7c16.JPG";